import React from "react";

import { omitBy } from "lodash";

import { Salutation } from "@hubcapp/types";

import { SalutationButtonsStateProviderProps } from "./types";
import SalutationButtons from "./SalutationButtons";

const ALLOWED_SALUTATIONS = [
  Salutation.Mr,
  Salutation.Miss,
  Salutation.Mrs,
  Salutation.Ms,
  Salutation.Mx,
];

const SalutationButtonsStateProvider: React.FC<SalutationButtonsStateProviderProps> = ({
  value,
  onChange = () => {},
  disabled,
  error,
}) => (
  <SalutationButtons
    value={value}
    onChange={onChange}
    salutations={Object.values(
      omitBy(Salutation, value => !ALLOWED_SALUTATIONS.includes(value)),
    )}
    error={error}
    disabled={disabled}
  />
);

export default SalutationButtonsStateProvider;
